import React from 'react';

import {
  CheckCircleOutline as BaseCheckCircleOutlineIcon,
  MonetizationOnOutlined as BaseMonetizationOnOutlinedIcon
} from '@mui/icons-material';
import {
  Box,
  styled,
  Typography
} from '@mui/material';
import moment from 'moment';



const GreenCheckCircleOutlineIcon = styled(BaseCheckCircleOutlineIcon)({
  color: '#6FCF97'
});

const GreyMonizationOnOutlineIcon = styled(BaseMonetizationOnOutlinedIcon)({
  color: '#C3D1D8'
});



interface IProps {
  completedAt: moment.Moment | null;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Box display='flex'>
      <Typography
        color={props.completedAt ? '#6FCF97' : '#C3D1D8'}>
        {getProgressString(props.completedAt)}
      </Typography>

      &nbsp;

      {props.completedAt
        ? <GreenCheckCircleOutlineIcon />
        : <GreyMonizationOnOutlineIcon />}
    </Box>
  );
};

function getProgressString(date: moment.Moment | null): string {
  if (!date) {
    return 'In Progress';
  }

  return `Completed ${date.format('MMM YYYY')}`;
}
